<template>
  <div id="app">
    <div class="menu-box">
      <div v-if="screenWidth <= 750" class="m_head">
        <img src="../assets/logo.png" class="logo">
        <img src="../assets/list.png" class="list" @click="menuClick">
      </div>
      <div class="menu-item" v-else>
        <div @click="choiceMenu(0)" :class="(menuIndex === 0) ? 'choice' : ''">{{ $t('menu_1') }}</div>
        <div @click="choiceMenu(1)" :class="(menuIndex === 1) ? 'choice' : ''">{{ $t('menu_2') }}</div>
        <div @click="choiceMenu(2)" :class="(menuIndex === 2) ? 'choice' : ''">{{ $t('menu_3') }}</div>
        <div @click="choiceMenu(3)" :class="(menuIndex === 3) ? 'choice' : ''">{{ $t('menu_4') }}</div>
        <div @click="choiceMenu(4)" :class="(menuIndex === 4) ? 'choice' : ''">{{ $t('menu_5') }}</div>
        <div @click="choiceMenu(5)" :class="(menuIndex === 5) ? 'choice' : ''">{{ $t('menu_6') }}</div>
        <div @click="choiceMenu(6)" :class="(menuIndex === 6) ? 'choice' : ''">{{ $t('menu_7') }} </div>

        <div class="show_list">
          <span>Language</span>
          <ul class="move_list">
            <li @click="$i18n.locale = 'th'">แบบไทย</li>
            <li @click="$i18n.locale = 'mk'">မြန်မာ</li>
          </ul>
        </div>
      </div>
      <transition name="bounce">
        <div class="menu-item" v-if="showMenu">
          <div @click="choiceMenu(0)" :class="(menuIndex === 0) ? 'choice' : ''">{{ $t('menu_1') }}</div>
          <div @click="choiceMenu(1)" :class="(menuIndex === 1) ? 'choice' : ''">{{ $t('menu_2') }}</div>
          <div @click="choiceMenu(2)" :class="(menuIndex === 2) ? 'choice' : ''">{{ $t('menu_3') }}</div>
          <div @click="choiceMenu(3)" :class="(menuIndex === 3) ? 'choice' : ''">{{ $t('menu_4') }}</div>
          <div @click="choiceMenu(4)" :class="(menuIndex === 4) ? 'choice' : ''">{{ $t('menu_5') }}</div>
          <div @click="choiceMenu(5)" :class="(menuIndex === 5) ? 'choice' : ''">{{ $t('menu_6') }}</div>
          <div @click="choiceMenu(6)" :class="(menuIndex === 6) ? 'choice' : ''">{{ $t('menu_7') }} </div>
        </div>
      </transition>
    </div>
    <div class="banner-box" id='home' ref="home">
      <img src="../assets/banner.png" class="banner">
      <div class="app_name">
        <div class="title">{{ $t('banner_1') }}</div>
        <div class="title-content">
          {{ $t('banner_2') }}
        </div>
      </div>
    </div>
    <div class="step-box" id='step' ref="step">
      <div class="title">{{ $t('step_1') }}</div>
      <div class="step-content">
        <div class="step-box-list">
          <img src="../assets/list-1.png" class="step-img">
          <!-- <p class="text-title">Need a CURP</p> -->
          <p class="text">{{ $t('step_2') }}</p>
        </div>
        <div class="step-box-list">
          <img src="../assets/list-2.png" class="step-img">
          <!-- <p class="text-title">Need a CURP</p> -->
          <p class="text">{{ $t('step_3') }}</p>
        </div>
        <div class="step-box-list">
          <img src="../assets/list-3.png" class="step-img">
          <!-- <p class="text-title">Need a CURP</p> -->
          <p class="text">{{ $t('step_4') }}</p>
        </div>
      </div>
    </div>
    <div class="product" id="product" ref="product">
      <div class="title">{{ $t('product_1') }}</div>
      <div class="product-content">
        <img src="../assets/product.png" class="product-img">
        <div class="product-item-text">
          <div>{{ $t('product_2') }}</div>
          <div>{{ $t('product_3') }}</div>
          <div>{{ $t('product_4') }}</div>
          <div>{{ $t('product_5') }}</div>
        </div>

      </div>
    </div>

    <div class="user" id='user' ref="user">
      <div class="title">{{ $t('user_1') }}</div>
      <div class="user-content">
        <div class="user-text-box">
          <div>{{ $t('user_2') }}</div>
          <div>{{ $t('user_3') }}</div>
          <div>{{ $t('user_4') }}</div>
        </div>
        <img src="../assets/user.png" class="user-img">
      </div>
    </div>

    <div class="about" id='about' ref="about">
      <div class="title">{{ $t('about_1') }}</div>
      <div class="about-content">
        <br> {{ $t('about_2') }}
        <br> {{ $t('about_3') }}
      </div>
    </div>

    <div class="privacy-box" id='privacy' ref="privacy">
      <div class="privacy-content-box " :class="(isMore) ? 'bottomhig' : 'maxhight'">
        <privacy></privacy>
      </div>
      <div class="get-more" @click="isMore = true" v-if="!isMore">
        <img src="../assets/get-more.png" alt="">
      </div>
    </div>

    <div class="del-data-box">
      <div class="tel-box" v-if="steps == 1">
        <div class="tip">{{ $t("del_data_1") }} </div>
        <div class="title">{{ $t("del_data_2") }}</div>
        <input v-model="mobile" type="text" class="tel-in" :placeholder="$t('del_data_3')">
        <input v-model="password" type="password" class="tel-pa" :placeholder="$t('del_data_4')">
        <div class="btn" @click="delSearch">{{ $t('del_data_5') }}</div>
      </div>
      <div class="tel-box" v-else-if="steps == 2">
        <div class="กล่องข้อความ">
          {{ $t('del_data_6') }}
          <br> {{ $t('del_data_7') }}
          <br> {{ $t('del_data_8') }}
          <br> {{ $t('del_data_9') }}
        </div>
        <div class="btn" @click="candelete">{{ $t('del_data_10') }}</div>
      </div>

      <div class="tel-box" v-else-if="steps == 3">
        <div class="title">{{ $t('del_data_11') }}</div>
        <div class="iump-box">
          <input v-model="code" type="text" class="car-in tel-in" :placeholder="$t('del_data_12')" />
          <div class="count-btn" @click="Reenviar"> {{ Time > 0 ? Time : '$t("del_data_13")' }} </div>
        </div>
        <div class="btn" @click="doDelete">{{ $t("del_data_14") }}</div>
      </div>

      <div class="tel-box del-box" v-else-if="steps == 4">
        <img src="../assets/del.png" alt="">
        <p>{{ $t("del_data_15") }}</p>
      </div>
      <div class="tel-box" v-else-if="steps == 5">
        <div class="title">{{ $t("del_data_16") }}</div>
        <input v-model="idcard" type="text" class="tel-in" :placeholder="$t('del_data_17')">
        <div class="btn" @click="verifyIdCard">{{ $t("del_data_18") }}</div>
      </div>
    </div>

    <div class="flex-box-item" v-if="msgDlg">
      <div class="msg-box">
        <div class="msg">
          <img src="../assets/title-err.png" class="err-img">
          {{ msg }}
        </div>
        <img src="../assets/close.png" class="close" @click="msgDlg = false">
      </div>
    </div>

    <div class="footer" id='footer' ref="footer">
      <div class="title">{{ $t('footer_1') }} </div>
      <div class="footer-content">
        <div class="time-box">
          <img src="../assets/time.png" class="time-img">
          <div class="time">
            {{ $t('footer_2') }}
          </div>
        </div>
        <div class="mail-box">
          <img src="../assets/mail.png" class="mail-img">
          <div class="mail">{{ $t('footer_3') }}</div>
        </div>
        <div class="address-box">
          <img src="../assets/address.png" class="address-img">
          <div class="address">
            {{ $t('footer_4') }}
          </div>
        </div>
      </div>
      <p class="bottom-text">© Copyright 2024 {{ $t('footer_5') }}.</p>
    </div>
  </div>
</template>

<script>
import privacy from "@/components/privacy";
import * as api from "@/api/api";
export default {
  name: 'App',
  components: {
    privacy
  },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      mobile: '',
      password: '',
      code: '',
      msgDlg: false,
      msg: '',
      steps: 1,
      infoData: {},
      Time: 0,
      idcard: '',
      verifyIDCard: '',
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    let lag = this.$route.query.lag
    if (lag == 'th' || lag == 'mk') {
      this.$i18n.locale = lag
    }
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("home").scrollIntoView(); break;
        case 1: document.getElementById("step").scrollIntoView(); break;
        case 2: document.getElementById("product").scrollIntoView(); break;
        case 3: document.getElementById("user").scrollIntoView(); break;
        case 4: document.getElementById("about").scrollIntoView(); break;
        case 5: document.getElementById("privacy").scrollIntoView(); break;
        case 6: document.getElementById("footer").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu
    },
    delSearch() {
      let data = {
        mobile: this.mobile,
        password: this.password
      }
      if (!this.mobile) {
        this.msg = 'หมายเลขโทรศัพท์มือถือต้องไม่เว้นว่าง'
        this.msgDlg = true
        return
      }
      if (!this.password) {
        this.msg = 'รหัสผ่านต้องไม่เว้นว่าง'
        this.msgDlg = true
        return
      }

      let loding = this.$loading.show({})
      api.delInfoSearch(data).then(res => {
        loding.hide()
        this.infoData = res.data
        this.steps = 2
      }).catch(e => {
        loding.hide()
        this.msg = e.message
        this.msgDlg = true
      })
    },
    candelete() {
      let data = {
        user_id: this.infoData.user_id
      }
      let loding = this.$loading.show({})
      api.delInfoCanDelete(data).then(res => {
        loding.hide()
        if (res.data.idcard) {
          this.verifyIDCard = res.data.idcard
          this.steps = 5
        } else {
          this.steps = 3
          this.Reenviar()
        }
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    verifyIdCard() {
      console.log(this.verifyIDCard);
      if (this.verifyIDCard == this.idcard) {
        this.steps = 3
        this.Reenviar()
      } else {
        this.msgDlg = true
        this.msg = 'ป้อนบัตรประจำตัวไม่ถูกต้องและการตรวจสอบล้มเหลว'
      }
    },
    Reenviar() {
      if (this.Time > 0) {
        return
      }
      this.Countdown(60)
      let data = {
        mobile: this.mobile
      }
      let loding = this.$loading.show({})
      api.delInfoSms(data).then(res => {
        loding.hide()
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    doDelete() {
      let loding = this.$loading.show({})
      let data = {
        mobile: this.mobile,
        code: this.code,
        user_id: this.infoData.user_id
      }
      api.delInfoDoDelete(data).then(res => {
        loding.hide()
        this.steps = 4
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    Countdown(time) {
      this.Time = time
      if (time <= 0) {
        return
      }

      setTimeout(() => {
        this.Countdown(time - 1)
      }, 1000);
    }
  }
}
</script>


<style lang="less" scoped>
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
